import { useEffect } from "react";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone, faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";

export const Kontak = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="w-full min-h-screen py-20 text-center text-gray-900 flex-col justify-center relative bg-white">
      <div className="container mx-auto px-4">
        
        <div className="max-w-6xl mx-auto space-y-4">
          <motion.div
            className="text-left"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <div className="bg-white rounded-xl px-4 py-6 border border-slate-200">
              <div className="space-y-4">
                {/* Email */}
                <motion.div
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.5, delay: 0.4 }}
                  viewport={{ once: true }}
                >
                  <div className="flex items-start">
                    <FontAwesomeIcon
                      icon={faEnvelope}
                      className="w-4 h-4 text-red-900 mt-1 mr-2"
                    />
                    <div>
                      <p className="text-md text-red-900 font-bold">Email</p>
                      <a
                        href="mailto:admin@cakrawalajakarta.id"
                        className="text-lg text-gray-900 hover:underline"
                      >
                        admin@cakrawalajakarta.id
                      </a>
                    </div>
                  </div>
                </motion.div>

                {/* WhatsApp / Phone */}
                <motion.div
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.5, delay: 0.5 }}
                  viewport={{ once: true }}
                >
                  <div className="flex items-start">
                    <FontAwesomeIcon
                      icon={faPhone}
                      className="w-4 h-4 text-red-900 mt-1 mr-2"
                    />
                    <div>
                      <p className="text-md text-red-900 font-bold">Phone</p>
                      <a
                        href="https://wa.me/628111816969"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-lg text-gray-900 hover:underline"
                      >
                        +62-811-1816-969
                      </a>
                    </div>
                  </div>
                </motion.div>
              </div>
            </div>
          </motion.div>

          {/* Location Map Section */}
          <motion.div
            className="text-left"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <div className="bg-white rounded-xl px-4 py-6 border border-slate-200">
              <div className="flex items-center gap-3 mb-4">
                <FontAwesomeIcon
                  icon={faMapMarkerAlt}
                  className="text-2xl text-red-900"
                />
                <div>
                  <h3 className="text-xl font-bold text-red-900">
                    Location
                  </h3>
                  <p className="text-sm text-gray-600">
                    Cibodas Botanical Garden
                  </p>
                </div>
              </div>

              <div className="w-full h-[400px] rounded-xl overflow-hidden shadow-sm border border-gray-100 mb-4">
                <iframe 
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3963.090566373783!2d107.0076085!3d-6.7412791!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69b388daf11bdb%3A0x2567561ff74bd6af!2sCibodas%20Botanical%20Garden!5e0!3m2!1sen!2sid!4v1701584000000!5m2!1sen!2sid"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Cibodas Botanical Garden Map"
                ></iframe>
              </div>

              <div className="space-y-1">
                <p className="text-lg font-bold text-gray-900">
                  Cibodas Botanical Garden
                </p>
                <p className="text-md text-gray-600">
                  Cianjur, West Java · Indonesia
                </p>
                <p className="text-sm text-gray-600 italic">
                  Alpine botanical gardens surrounded by lush mountain vegetation
                </p>
              </div>
              
              <div className="mt-4">
                <a
                  href="https://www.google.com/maps/place/Cibodas+Botanical+Garden/@-6.7412791,107.0076085,831m/data=!3m2!1e3!4b1!4m6!3m5!1s0x2e69b388daf11bdb:0x2567561ff74bd6af!8m2!3d-6.7412791!4d107.0076085!16s%2Fm%2F05c2957!18m1!1e1?entry=ttu"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block text-gray-900 font-semibold hover:text-gray-700 hover:underline"
                >
                  View on Google Maps &rarr;
                </a>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
